<!-- 注册 -->
<template>
  <div class="login">
    <div class="main">
      <img src="../assets/loginImg.png" alt="" />
      <div class="main_right">
        <div class="title">
          <div class="left"><i></i><span>注册账号</span></div>
          <div class="right">
            已有账号?<router-link to="/login">立即登录</router-link>
          </div>
        </div>
        <div class="form">
          <li>
            <input v-model="form.tel" type="text" placeholder="请输入手机号" />
            <p>手机号</p>
            <span @click="sendCode" :disabled="isSending">{{
              countdown > 0 ? `${countdown}s后重试` : "发送验证码"
            }}</span>
          </li>
          <li>
            <input v-model="form.code" type="text" placeholder="请输入验证码" />
            <p>验证码</p>
          </li>
          <li>
            <input
              v-model="form.account"
              type="text"
              placeholder="请输入账号"
            />
            <p>账号</p>
          </li>
          <li>
            <input
              v-model="form.password"
              type="password"
              placeholder="请输入密码"
            />
            <p>设置密码</p>
          </li>
          <li>
            <input
              v-model="form.confirmPassword"
              type="password"
              placeholder="请再次输入密码"
            />
            <p>确认密码</p>
          </li>
        </div>
        <button @click="handleRegister">注册</button>
        <li>
          创建账户即表示您同意的<router-link to="/clause"
            >条款和条件</router-link
          >以及<router-link to="/privacyPolicy">隐私政策</router-link>
        </li>
      </div>
    </div>
  </div>
</template>

<script>
import { getCode, getRegister } from "../api/userApi";
export default {
  data() {
    return {
      form: {
        tel: "",
        code: "",
        account: "",
        password: "",
        confirmPassword: "",
      },
      isSending: false,
      countdown: 0,
      timer: null,
    };
  },
  // async created() {
  //   // 获取用户信息
  //   await this.getCode();
  //   await this.getRegister();
  // },
  methods: {
    // async getCode() {
    //   try {
    //     const response = await getCode();
    //     console.log(response.data);
    //     // if (response.code === 1) {
    //     // }
    //   } catch (error) {
    //     console.error("获取接口失败", error);
    //   }
    // },

    // async getRegister() {
    //   try {
    //     const response = await getRegister();
    //     console.log(response.data);
    //     // if (response.code === 1) {
    //     // }
    //   } catch (error) {
    //     console.error("获取接口失败", error);
    //   }
    // },

    async sendCode() {
      console.log(111);
      // 验证手机号
      if (!this.form.tel) {
        this.$message.error("请输入手机号");
        return;
      }

      // 防止重复发送
      if (this.isSending || this.countdown > 0) return;

      this.isSending = true;

      try {
        const params = {
          tel: this.form.tel,
        };
        const response = await getCode(params);
        if (response.code === 1) {
          this.$message.success("验证码已发送");
          // 开始倒计时
          this.countdown = 60;
          this.timer = setInterval(() => {
            this.countdown--;
            if (this.countdown <= 0) {
              clearInterval(this.timer);
              this.isSending = false;
            }
          }, 1000);
        } else if (response.code === 0) {
          this.$message.error(response.msg);
        } else {
          this.$message.error(response.msg);
          this.isSending = false;
        }
      } catch (error) {
        console.error("获取验证码失败", error);
        this.$message.error("获取验证码失败");
        this.isSending = false;
      }
    },
    async handleRegister() {
      // 验证表单
      if (!this.form.tel) {
        this.$message.error("请输入手机号");
        return;
      }
      if (!this.form.code) {
        this.$message.error("请输入验证码");
        return;
      }
      if (!this.form.account) {
        this.$message.error("请输入账号");
        return;
      }
      if (!this.form.password) {
        this.$message.error("请输入密码");
        return;
      }
      if (this.form.password !== this.form.confirmPassword) {
        this.$message.error("两次输入的密码不一致");
        return;
      }

      try {
        // const data = {
        //   tel: this.form.tel,
        //   code: this.form.code,
        //   account: this.form.account,
        //   password: this.form.password,
        // };
        const response = await getRegister(
          this.form.tel,
          this.form.code,
          this.form.account,
          this.form.password
        );

        if (response.code === 1) {
          this.$message.success("注册成功");
          this.$router.push("/login");
        } else if (response.code === 0) {
          this.$message.error(response.msg);
        } else {
          this.$message.error(response.msg || "注册失败");
        }
      } catch (error) {
        console.error("注册失败", error);
        this.$message.error("注册失败");
      }
    },

    beforeDestroy() {
      // 清除定时器
      if (this.timer) {
        clearInterval(this.timer);
      }
    },
  },
};
</script>

<style scoped lang="less">
li {
  list-style: none;
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.login {
  background: url(../assets/loginBg.png) no-repeat center/cover;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  .main {
    width: 1200px;
    height: 700px;
    background: #ffffff;
    box-shadow: 0px 3px 32px 0px rgba(52, 96, 161, 0.1098);
    border-radius: 16px 16px 16px 16px;
    display: flex;
    .main_right {
      padding: 45px 110px 43px 80px;
      box-sizing: border-box;
      .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .left {
          display: flex;
          align-items: center;
        }
        .right {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #121212;
          a {
            color: rgba(23, 93, 194, 1);
          }
        }
        i {
          width: 6px;
          height: 32px;
          background: #175dc2;
          display: block;
        }
        span {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 28px;
          color: #06213d;
          margin-left: 20px;
        }
      }
      .form {
        margin: 48px 0 35px 0;
        li {
          margin-bottom: 40px;
          position: relative;
          width: 400px;
          height: 48px;
          background: #ffffff;
          border-radius: 4px;
          border: 1px solid #adb8d3;
          display: flex;
          justify-content: space-between;
          //   align-items: center;
          span {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #175dc2;
            margin: 16px;
            line-height: 12px;
            cursor: pointer;
          }
          img {
            width: 101px;
            height: 36px;
            margin: 6px 12px 6px 0;
          }
          input {
            outline: none;
            border: none;
            width: 200px;
            height: 35px;
            margin: 9px 0;
            padding-left: 32px;
          }
          input::placeholder {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: rgba(133, 136, 143, 0.3);
            padding: 16px 0;
          }
          input::focus {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 20px;
            color: rgba(133, 136, 143, 1);
            padding: 16px 0;
          }

          p {
            position: absolute;
            top: -15px;
            left: 20px;
            // width: 72px;
            padding: 0 12px;
            height: 22px;
            background: #ffffff;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #85888f;
          }
        }
        li:last-child {
          margin-bottom: 0;
        }
      }
      button {
        width: 400px;
        height: 48px;
        border: none;
        outline: none;
        cursor: pointer;
        background: #175dc2;
        box-shadow: 0px 3px 12px 0px rgba(153, 156, 163, 0.302);
        border-radius: 24px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 20px;
        color: #ffffff;
        letter-spacing: 3px;
        margin-bottom: 25px;
      }
      li {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #121212;
        a {
          color: rgba(23, 93, 194, 1);
          border-bottom: 1px solid rgba(23, 93, 194, 1);
        }
      }
    }
  }
}
</style>
